var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container" },
    _vm._l(_vm.list, function (item, id) {
      return _c("div", {
        key: id,
        class: _vm.getClass(id),
        domProps: { innerHTML: _vm._s(item) },
        on: {
          mouseenter: function ($event) {
            return _vm.highlightItem(id)
          },
          mouseleave: function ($event) {
            return _vm.highlightItem(null)
          },
          click: function ($event) {
            return _vm.openDetail(id, $event)
          },
        },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }